export default {
  title: 'Security',

  labels: {
    disActive: 'Compulsory exit period if not active',
    minute: 'minute'
  }
}
